

































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Module } from '@/interfaces/Module';
import { Step } from '@/interfaces/Step';
import { Attribute } from '@/interfaces/Attribute';

@Component({})
export default class AttributesViewCardTable extends Vue {
  @Prop()
  attribute!: Attribute;

  get getAttributePaths(): any[] {
    const { attribute } = this;
    const cutoverplanMap: Record<number, any> = {};

    attribute.modules.forEach((module: Module) => {
      const { cutoverplan } = module;

      if (!cutoverplan) {
        return;
      }

      if (!cutoverplanMap[cutoverplan.id]) {
        cutoverplanMap[cutoverplan.id] = { cutoverplan, modules: {} };
      }

      cutoverplanMap[cutoverplan.id].modules[module.id] = { module, steps: [], actually: true };
    });

    attribute.steps.forEach((step: Step) => {
      const { module } = step;
      const { cutoverplan } = module;

      if (!cutoverplan) {
        return;
      }

      if (!cutoverplanMap[cutoverplan.id]) {
        cutoverplanMap[cutoverplan.id] = {
          cutoverplan,
          modules: { [module.id]: { module, steps: [step] } }
        };
      } else if (!cutoverplanMap[cutoverplan.id].modules[module.id]) {
        cutoverplanMap[cutoverplan.id].modules[module.id] = { module, steps: [step] };
      } else {
        if (!cutoverplanMap[cutoverplan.id].modules[module.id].steps)
          cutoverplanMap[cutoverplan.id].modules[module.id].steps = [];
        cutoverplanMap[cutoverplan.id].modules[module.id].steps.push(step);
      }
    });

    Object.values(cutoverplanMap).forEach((cutoverplan: any) => {
      cutoverplan.modules = Object.values(cutoverplan.modules);
    });

    return Object.values(cutoverplanMap);
  }
}
